module.exports = "<div class=\"gw-tabbable\">\r\n    <ul class=\"gw-nav gw-nav-flavor-{{_flavor}}\" ng-transclude>\r\n    </ul>\r\n    <div class=\"gw-tab-content\">\r\n        <div class=\"gw-tab-pane\"\r\n             ng-repeat=\"tab in tabs\"\r\n             ng-class=\"{'gw-active': tab.active}\"\r\n             tab-content-transclude=\"tab\">\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/tabs/templates/tabset-template.html
// module id = 596
// module chunks = 0